import {Routes} from '@angular/router';
import {authGuard} from '../../../sdk/src/guards/auth-guard.guard';
import {CustomerLayoutComponent} from './customer-layout.component';
import {CSUserRolesPage} from './settings/cs-user-roles-page.component';
import {CSCustomerUserMembershipsPage} from './settings/cs-customer-user-memberships-page.component';
import {COInstancesPageComponent} from './organizations/co-instances-page.component';
import {CPGInstancesPageComponent} from './projects/cp-instances-page.component';
import {CSRInstancesPageComponent} from './service-requests/csr-instances-page.component';
import {CPOverviewPageComponent} from './project/cp-overview-page.component';
import {CSROverviewPageComponent} from './service-request/csr-overview-page.component';
import {COSObjectStoreEntryPage} from './object-store/cos-object-store-entry-page.component';
import {CustomerFilesPageComponent} from './customer-files-page.component';
import {CGInstancesPageComponent} from './groups/cg-instances-page.component';
import {COOverviewPageComponent} from './organization/co-overview-page.component';

export const customerRoutes: Routes = [
    {
        path: 'customer/:customerUUID',
        canActivate: [authGuard],
        canActivateChild: [authGuard],
        component: CustomerLayoutComponent,
        children: [
            {
                path: '',
                redirectTo: 'service-request',
                pathMatch: 'full'
            },

            // ===============================================================
            // ===============================================================

            {
                path: 'organization',
                title: 'Organizations',
                component: COInstancesPageComponent,
                pathMatch: 'full'
            },
            {
                path: 'organization/:organizationUUID',
                children: [
                    {path: '', component: COOverviewPageComponent, pathMatch: 'prefix'},
                    {
                        path: 'location',
                        component: COOverviewPageComponent,
                        pathMatch: 'full',
                        data: {
                            tab: 'hierarchy'
                        }
                    },
                    {
                        path: 'location/:locationUUID',
                        component: COOverviewPageComponent,
                        pathMatch: 'prefix',
                        data: {
                            tab: 'hierarchy'
                        }
                    }
                ]
            },

            // ===============================================================
            // ===============================================================

            {
                path: 'project',
                title: 'Projects',
                component: CPGInstancesPageComponent,
                pathMatch: 'full'
            },
            {
                path: 'project/:projectUUID',
                component: CPOverviewPageComponent,
                pathMatch: 'prefix'
            },

            // ===============================================================
            // ===============================================================

            {
                path: 'groups',
                title: 'Groups',
                component: CGInstancesPageComponent,
                pathMatch: 'full'
            },

            // ===============================================================
            // ===============================================================

            {
                path: 'service-request',
                title: 'Service Requests',
                component: CSRInstancesPageComponent,
                pathMatch: 'full'
            },

            {
                path: 'service-request/:serviceRequestUUID',
                title: 'Service Request',
                component: CSROverviewPageComponent
            },

            // ===============================================================
            // ===============================================================

            {
                path: 'settings',
                children: [
                    {path: '', redirectTo: 'customer-user-memberships', pathMatch: 'full'},
                    {path: 'user-roles', component: CSUserRolesPage},
                    {path: 'customer-user-memberships', component: CSCustomerUserMembershipsPage},
                    {
                        path: 'object-store',
                        title: 'Object Store',
                        component: COSObjectStoreEntryPage,
                        pathMatch: 'prefix',
                        data: {
                            linkObjectType: 'customer',
                            linkObjectUUID: ':customerUUID'
                        }
                    },
                    {
                        path: 'files',
                        title: 'Files',
                        component: CustomerFilesPageComponent
                    }
                ]
            }
        ]
    }
];
